import { CEIdentityAttributesBase } from './ce-identity-attributes-base'


export class CEIdentityAttributes extends CEIdentityAttributesBase {

}